module.exports = __webpack_public_path__ + "static/media/underline.c0b3f795.svg";